import { Box } from '@mui/material';
import { notUndefiend, valueAsString } from 'helpers/conversions';
import React from 'react';
import { ICardProps, StatsData } from './Card';
import { Spinner, SpinnerContainer } from './Styles';
import { styles } from './ProductionRateCardMobileDtf.styles';

const ProductionRateCardMobileDtf = (props: ICardProps) => {
  const { value, units, description, icons, stats, statsDescription, isPercentage } = props;
  const isNegative = React.useMemo(() => {
    if (!notUndefiend([stats])) {
      return false;
    }
    if (stats! < 0) {
      return true;
    }
    if (description === 'Average Availability' && value !== undefined && value >= 0.999) {
      return false;
    }
    return false;
  }, [description, stats, value]);
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      width="100%"
      height="100%"
      boxSizing="border-box"
      data-testid="production-rate-card-mobile">
      {notUndefiend([value]) ? (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          width="100%"
          height="100%"
          boxSizing="border-box"
          sx={styles.leftColumn}
          data-testid="left-column">
          <Box display="flex" flexDirection="column" height="70px" boxSizing="border-box" data-testid="upper-row">
            <Box display="flex" alignItems="flex-start" data-testid="value-sub-row">
              <Box sx={styles.icon} data-testid="icon-container">
                {isNegative ? icons.negative : icons.positive}
              </Box>

              <Box sx={styles.value(value)} data-testid="production-rate-value">
                {valueAsString(value, isPercentage)}
              </Box>
              <Box sx={styles.units} data-testid="production-rate-units">
                {units}
              </Box>
            </Box>
            <Box
              display="flex"
              justifyContent="flex-start"
              alignItems="flex-start"
              sx={styles.leftColUpperRowDescriptionSubRow}
              data-testid="description-sub-row">
              {description}
            </Box>
          </Box>
          <Box
            display="flex"
            alignItems="flex-end"
            height="30px"
            boxSizing="border-box"
            sx={styles.leftColBottomRow}
            data-testid="production-rate-description">
            {notUndefiend([stats]) && StatsData(stats)} {statsDescription}
          </Box>
        </Box>
      ) : (
        <SpinnerContainer>{Spinner()}</SpinnerContainer>
      )}
    </Box>
  );
};
export default ProductionRateCardMobileDtf;

